const emailErrorCodes = {
  'server-error-while-sending-email': 'server error while sending email'
};

export default emailErrorCodes;
